import { cva as e } from "class-variance-authority";
// src/design/breadcrumbs/styles.ts
var t = e("flex items-center gap-1 flex-wrap m-0 p-0 list-none"), n = e("flex items-center gap-1 h-8"), r = e("inline-block  rounded px-1.5 py-1 -mx-2 -my-1 font-normal transition-colors text-sm", {
	variants: { isLast: {
		true: "text-foreground font-semibold",
		false: "text-foreground/85 max-w-64 truncate hover:text-foreground hover:bg-muted"
	} },
	defaultVariants: { isLast: !1 }
});
export { n as breadcrumbItemStyles, r as breadcrumbLinkStyles, t as breadcrumbRootStyles };

//# sourceMappingURL=styles.js.map